package model

import kotlinx.serialization.Serializable

@Serializable
data class ErrorReportBody(
    val message: String
)